import * as React from 'react'
import styled from 'styled-components'
import { fontSizes } from '@src/styles/theme'
import { EquabotzScope } from '../services/equabotz-config'

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: ${(props: any) => props.theme.panelBack || 'rgba(255,255,255,0.04)'};
  border-bottom: 1px solid rgba(206, 218, 225, 0.15);
`

const Label = styled.span`
  font-size: ${fontSizes.XXS};
  font-family: 'NunitoSansSemiBold';
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

const ScopeHint = styled.span`
  font-size: ${fontSizes.XXS};
  font-family: 'NunitoSans';
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
`

const Select = styled.select`
  background: ${(props: any) => props.theme.inputBack || '#262A36'};
  color: ${(props: any) => props.theme.white || '#FFF'};
  border: 1px solid rgba(206, 218, 225, 0.25);
  border-radius: 4px;
  padding: 6px 10px;
  font-size: ${fontSizes.XXS};
  font-family: 'NunitoSans';
  cursor: pointer;
  min-width: 220px;

  &:focus {
    outline: none;
    border-color: #33AA40;
  }
`

interface ScopeSelectorProps {
  scopes: EquabotzScope[]
  value: EquabotzScope
  onChange: (next: EquabotzScope) => void
  locked?: boolean
}

export const ScopeSelector: React.FC<ScopeSelectorProps> = ({ scopes, value, onChange, locked }) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const next = scopes.find(s => `${s.kind}:${s.id}` === e.target.value)
    if (next) onChange(next)
  }

  return (
    <Bar>
      <Label>Gateway scope</Label>
      <Select
        value={`${value.kind}:${value.id}`}
        onChange={handleChange}
        disabled={locked}
        aria-label="Gateway scope"
      >
        {scopes.map(s => (
          <option key={`${s.kind}:${s.id}`} value={`${s.kind}:${s.id}`}>
            {s.label}
          </option>
        ))}
      </Select>
      <ScopeHint>Scope: {value.label}; gateway token comes from saved settings.</ScopeHint>
    </Bar>
  )
}
